import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faFileAlt, faBell } from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logoWOBGD.PNG";
import man from "../../assets/icons/man.PNG";


const TopNavBar: React.FC = () => {
    const navigate = useNavigate();

    const handleProfile = () => {
        navigate("/profile");
    };

    const handleLogoClick = () => {
        navigate("/");
    }

    return (
        <nav className="navbarMainStyles">
            <ul className="navbarulStyles">
                <img src={logo} alt="Logo" className="navbarlogoStyles" onClick={handleLogoClick}/>
                <div className="navbarIconStyleDiv">
                    <FontAwesomeIcon icon={faPhone} className="navbarIconStyles" />
                    <FontAwesomeIcon icon={faFileAlt} className="navbarIconStyles" />
                    <FontAwesomeIcon icon={faBell} className="navbarIconStyles" />
                    <div>
                        <img
                            className="avertaStyle"
                            src={man}
                            alt="Login Cover"
                            onClick={handleProfile}
                        />
                    </div>
                </div>
            </ul>
        </nav>
    );
};

export default TopNavBar;
